import './_components.js';
var swiper = new Swiper(".testimonials__items", {
  cssMode: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
  },
  mousewheel: true,
  keyboard: true,
});



document.querySelectorAll(".media").forEach((block) => {
  const buttons = block.querySelectorAll(".filter-btn");
  const cards = block.querySelectorAll(".media__card");
  const modal = document.getElementById("mediaModal");
  const modalBody = modal.querySelector(".media-modal__body");
  const closeBtn = modal.querySelector(".media-modal__close");

  // фильтрация
  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      buttons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      const filter = btn.dataset.filter;
      cards.forEach((card) => {
        card.style.display =
          filter === "all" || card.dataset.category === filter ? "block" : "none";
      });
    });
  });

  // открытие
  cards.forEach((card) => {
    card.addEventListener("click", () => {
      const type = card.dataset.type;
      const src = card.dataset.src;
      modalBody.innerHTML = "";

      if (type === "image") {
        const img = document.createElement("img");
        img.src = src;
        modalBody.appendChild(img);
      } else if (type === "video") {
        const iframe = document.createElement("iframe");
        iframe.src = src + "?autoplay=1&rel=0";
        iframe.allow =
          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        iframe.allowFullscreen = true;
        modalBody.appendChild(iframe);
      }

      modal.classList.add("active");
    });
  });

  closeBtn.addEventListener("click", closeModal);
  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });

  function closeModal() {
    modal.classList.remove("active");
    setTimeout(() => (modalBody.innerHTML = ""), 300);
  }
});



var swiper = new Swiper(".media__slider", {
  slidesPerView: 3,
  spaceBetween: 30,
  cssMode: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
  },
  mousewheel: true,
  keyboard: true,
  breakpoints: {
    // от 0 до 399 — 1 слайд
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    // от 400 до 899 — 2 слайда
    600: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    // от 900 и выше — 3 слайда
    900: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});


import GraphTabs from 'graph-tabs';
const programTabs = new GraphTabs('program-tabs');

// Второй набор табов
const galleryTabs = new GraphTabs('programs-tabs');






(function () {
  const input = document.getElementById('files-upload');
  const list = document.querySelector('.contacts__upload-list');

  if (!input || !list) return;

  input.addEventListener('change', function () {
    list.innerHTML = '';
    const files = Array.from(input.files || []);
    if (files.length === 0) {
      list.textContent = '';
      return;
    }

    files.forEach(f => {
      const el = document.createElement('span');
      el.className = 'contacts__upload-file';
      // обрезаем длинные имена
      const name = f.name.length > 30 ? f.name.slice(0, 28) + '…' : f.name;
      el.textContent = name;
      list.appendChild(el);
    });
  });

  // keyboard accessibility: нажать Enter/Space на label тоже откроет диалог (по умолчанию работает),
  // если нужно — можно добавить обработчик клавиш.
})();







document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-select]").forEach(select => {
    const trigger = select.querySelector("[data-select-trigger]");
    const options = select.querySelector(".form__custom-options");
    const hiddenInput = select.querySelector("input[type='hidden']");

    trigger.addEventListener("click", () => {
      select.classList.toggle("open");
      trigger.classList.toggle("active");
    });

    options.querySelectorAll("li").forEach(option => {
      option.addEventListener("click", () => {
        trigger.textContent = option.textContent;
        hiddenInput.value = option.dataset.value;
        select.classList.remove("open");
        trigger.classList.remove("active");
      });
    });

    document.addEventListener("click", e => {
      if (!select.contains(e.target)) {
        select.classList.remove("open");
        trigger.classList.remove("active");
      }
    });
  });
});




document.addEventListener('DOMContentLoaded', () => {
  const burger = document.querySelector('[data-burger]');
  const menu = document.querySelector('[data-menu]');
  const links = document.querySelectorAll('.header__menu-link');

  if (!burger || !menu) return;

  burger.addEventListener('click', () => {
    burger.classList.toggle('active');
    menu.classList.toggle('menu--active');

    const isOpen = burger.classList.contains('active');
    burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  links.forEach(link => {
    link.addEventListener('click', () => {
      burger.classList.remove('active');
      menu.classList.remove('menu--active');
      burger.setAttribute('aria-expanded', 'false');
    });
  });
});



import GraphModal from 'graph-modal';
const modal = new GraphModal();



document.querySelectorAll('.faq-question').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  });
});